import type { ReactNode } from 'react';

/** A labeled landmark region. Real heading + aria-labelledby so the section
 *  structure is navigable by screen readers. `kicker` is a small overline that
 *  names the KIND of panel (e.g. "Market sentiment", "Context") so odds/money
 *  are never mistaken for the count. */
export function Section({
  id,
  title,
  kicker,
  subtitle,
  children,
  /** On wide screens: 'full' spans both grid columns; 'half' takes one. */
  span = 'full',
}: {
  id: string;
  title: string;
  kicker?: string;
  subtitle?: ReactNode;
  children: ReactNode;
  span?: 'full' | 'half';
}) {
  const headingId = `${id}-heading`;
  return (
    <section
      id={id}
      className={`section section--${span}`}
      aria-labelledby={headingId}
    >
      <div className="section__head">
        {kicker ? <p className="section__kicker">{kicker}</p> : null}
        <h2 id={headingId} className="section__title">
          {title}
        </h2>
        {subtitle ? <div className="section__subtitle">{subtitle}</div> : null}
      </div>
      <div className="section__body">{children}</div>
    </section>
  );
}
